module.exports = __webpack_public_path__ + "353fee8ffd748586674d5fb6fa7ddf23.pdf";